import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Menu from "../components/Menu";
import WalletForm from "../components/WalletForm";
import SocialShare from "../components/SocialShare";
import { TranslationContext } from "../contexts/TranslationContext";

const MyWallet = () => {
  const { translations, routes } = useContext(TranslationContext);
  const url = window.location.href; // The current page URL
  const title = 'Premium Wallet - O.A.V.L.I.T.E';


  return (
    <>
      <Helmet>
        <title>{translations.premiumWallet} - O.A.V.L.I.T.E</title>
      </Helmet>
      <div className="navbar-header container-fluid px-3 pt-2 mb-5">
        <div className="w-100"></div>
        <div className="text-center logo-wrapper pt-3">
          <Link to="/" className="logo-link">
            <img
              src="../images/oavlite-black.png"
              className="img-fluid mx-auto text-center d-block d-logo mb-3"
              alt="oavlite"
            />
          </Link>
          <p className="mb-2 fw-500 tagline__1">
            {translations.taglineV1} 
          </p>
           
        </div>
        <Menu />
      </div>
      <div className="w-100 my-wallet-wrap text-center position-absolute mx-auto">
        <div className="container-xxl px-5">
          <div className="center-content mb-3">
            <WalletForm />
          </div>
        </div>
      </div>

      <footer className="text-center d-footer">
        <SocialShare url={url} title={title} />
       <p>
                 <Link className="color-primary" to={routes.legalNotices}>
                   CGU
                 </Link>
               </p>
      </footer>
    </>
  );
};

export default MyWallet;
